import React, { useState } from "react";
import { toast } from "sonner";
import { DownloadSimple, Copy } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LegalHoldExport = ({ token }) => {
  const [busy, setBusy] = useState("");
  const headers = { Authorization: `Bearer ${token}` };

  const download = async () => {
    setBusy("zip");
    try {
      const res = await fetch(`${API}/admin/legal-hold/export.zip`, { headers });
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const name = (res.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1] || "farmwatch-legal-hold.zip";
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(blob), download: name });
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success("Legal hold archive downloaded");
    } catch { toast.error("Export failed"); } finally { setBusy(""); }
  };

  const copyUrls = async () => {
    setBusy("urls");
    try {
      const res = await fetch(`${API}/admin/legal-hold/removed-urls`, { headers });
      const text = await res.text();
      await navigator.clipboard.writeText(text);
      toast.success(`${text.trim().split("\n").filter(Boolean).length} removed URLs copied — paste into Search Console › Removals`);
    } catch { toast.error("Could not copy URLs"); } finally { setBusy(""); }
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="legal-hold-export">
      <button onClick={download} disabled={!!busy} data-testid="legal-hold-download-btn"
        className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-semibold bg-[#111827] text-white hover:bg-[#0F766E] disabled:opacity-50">
        <DownloadSimple size={14} /> {busy === "zip" ? "Preparing…" : "Download legal hold (zip)"}
      </button>
      <button onClick={copyUrls} disabled={!!busy} data-testid="legal-hold-copy-urls-btn"
        className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-semibold border border-[#E0D4C8] bg-white text-[#374151] hover:border-[#0F766E] disabled:opacity-50">
        <Copy size={14} /> Copy removed URLs for Search Console
      </button>
    </div>
  );
};
